import React, { useEffect, useState, useRef } from "react";
import classes from "./Purchaseinvoice.module.css";
import invoicePreviewClasses from "../Invoice Preview/Reportinvoice.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2, Printer } from "lucide-react";
import { useReactToPrint } from "react-to-print";
import axios from "axios";
import api, { BASE_URL, getAuthHeaders, withCompanyId } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from 'sweetalert2';
import NewItem from "./NewItem";
import { QRCodeSVG } from "qrcode.react";


const Purchase = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectMetrics, setSelectedMetrics] = useState(null);
  const printRef = useRef();
  const [previewInvoice, setPreviewInvoice] = useState(null);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [companyInfo, setCompanyInfo] = useState(null);
  
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };





  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const res = await axios.get(`${BASE_URL}/v1/fetch-purchases-invoice`, {
  //         headers: getAuthHeaders(),
  //       });
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);


  useEffect(() => {
  const fetchInvoices = async () => {
    try {
      const res = await api.get("/v1/fetch-purchases-invoice");

      if (res.data?.status && Array.isArray(res.data.data)) {
        setInvoices(res.data.data);
      }
    } catch {
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  };

  fetchInvoices();
}, []);

  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };


  const getDeliveryStatus = (item) => {
    const rawValue = item?.is_supplied ?? item?.delivery_status ?? item?.status;

    if (rawValue == 1 || rawValue === "1") {
      return { text: "delivered", class: classes.greenStatus };
    }
    if (rawValue == 0 || rawValue === "0") {
      return { text: "not delivered", class: classes.yellowStatus };
    }

    return { text: String(rawValue || "not delivered"), class: classes.yellowStatus };
  };
  useEffect(() => {


    const fetchMetrics = async () => {
      try {
        const res = await api.get("/v1/metrics/purchase-invoice-matrix");
        if (res.data && res.data.status && res.data.data) {
          setSelectedMetrics(res.data.data);
        }
      } catch (err) {
        setSelectedMetrics(null);
      }
    };
    fetchMetrics();
  }, []);

  const printPreview = useReactToPrint({
    contentRef: printRef,
    documentTitle: `Purchase-Invoice-${previewInvoice?.invoice_number || previewInvoice?.document_number || ""}`,
    pageStyle: `
      @page { margin: 12mm; }
      html, body { margin: 0; background: #fff; color: #222; }
      #purchase-invoice-modal-print * { visibility: visible !important; }
      #purchase-invoice-modal-print {
        display: block !important;
        box-sizing: border-box !important;
        padding: 10mm 8mm !important;
      }
      #purchase-invoice-modal-print .${invoicePreviewClasses.header} {
        display: flex !important;
        flex-direction: row !important;
        align-items: flex-start !important;
        justify-content: space-between !important;
        gap: 20px !important;
      }
      #purchase-invoice-modal-print .${invoicePreviewClasses.company} {
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
        flex: 1 1 auto !important;
      }
      #purchase-invoice-modal-print .${invoicePreviewClasses["invoice-title"]} {
        display: block !important;
        flex: 0 0 auto !important;
        margin-left: auto !important;
        text-align: right !important;
      }
      #purchase-invoice-modal-print .${invoicePreviewClasses.items} th {
        color: #fff !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      .${classes.printPreviewOverlay}, .${classes.printPreviewHeader}, .${classes.printPreviewActions} { display: none !important; }
      .${invoicePreviewClasses.invoiceBox || "invoice-box"} { box-shadow: none !important; border: 0 !important; }
    `,
  });

  const getPreviewItems = (invoice) => {
    const itemCollection = [
      invoice?.items,
      invoice?.invoice_items,
      invoice?.purchase_invoice_items,
      invoice?.purchase_items,
      invoice?.lines,
    ].find(Array.isArray);

    if (itemCollection) return itemCollection;

    const arrayFields = ["item_id", "quantity", "item_amount", "reference"];
    const lineCount = Math.max(
      ...arrayFields.map(field => Array.isArray(invoice?.[field]) ? invoice[field].length : 0)
    );

    return Array.from({ length: lineCount }, (_, index) => ({
      item_id: invoice.item_id?.[index],
      quantity: invoice.quantity?.[index],
      item_amount: invoice.item_amount?.[index],
      reference: invoice.reference?.[index],
    }));
  };

  const previewItems = previewInvoice ? getPreviewItems(previewInvoice) : [];
  const previewTotal = Number(previewInvoice?.amount ?? previewInvoice?.total_price ?? previewInvoice?.total ?? 0);
  const previewItemTotal = previewItems.reduce(
    (sum, item) => sum + Number(item.item_amount ?? item.line_total ?? item.total ?? item.amount ?? 0),
    0
  );
  const previewSubtotal = Number(
    previewInvoice?.sub_total ??
    previewInvoice?.subtotal ??
    (previewItemTotal || previewTotal)
  );
  const previewVat = Number(previewInvoice?.total_vat ?? previewInvoice?.vat_amount ?? 0);
  const previewDiscount = Number(previewInvoice?.total_discount ?? previewInvoice?.discount_amount ?? 0);
  const companyBankName = companyInfo?.bank_name || previewInvoice?.company?.bank_name || "—";
  const companyAccountName =
    companyInfo?.account_name ||
    previewInvoice?.company?.account_name ||
    companyInfo?.name ||
    previewInvoice?.company?.name ||
    "—";
  const companyAccountNumber = companyInfo?.account_number || previewInvoice?.company?.account_number || "—";
  const companyLogo =
    companyInfo?.logo ||
    previewInvoice?.company?.logo ||
    previewInvoice?.business?.logo ||
    previewInvoice?.organization?.logo ||
    previewInvoice?.company_logo ||
    "/promix.png";
  const qrCodeValue = previewInvoice ? JSON.stringify({
    type: "Purchase Invoice",
    invoiceNumber: previewInvoice.invoice_number || previewInvoice.document_number || previewInvoice.uuid || "",
    supplier: previewInvoice.supplier?.name || previewInvoice.supplier_name || "",
    date: previewInvoice.transaction_date || previewInvoice.invoice_date || "",
    dueDate: previewInvoice.due_date || "",
    amount: previewTotal,
  }) : "";

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      if (!previewInvoice || companyInfo) return;

      try {
        const response = await api.get("/v1/companies/get-info");
        const company = Array.isArray(response?.data?.data)
          ? response.data.data[0]
          : response?.data?.data;
        if (company) {
          setCompanyInfo(company);
        }
      } catch (error) {
        console.error("Failed to fetch company details for purchase invoice preview:", error);
      }
    };

    fetchCompanyInfo();
  }, [previewInvoice, companyInfo]);

  const formatInvoiceAmount = (value) => Number(value || 0).toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const handleOpenFullPreview = () => {
    if (!previewInvoice) return;
    navigate("/invoice-previeww", {
      state: { invoice: previewInvoice, pageTitle: "Purchase Invoice" },
    });
  };

  const handleReversePurchaseInvoice = async (item) => {
    // Confirm deletion
    const result = await Swal.fire({
      title: 'Reverse Purchase Invoice',
      text: 'Are you sure you want to reverse this purchase invoice? This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reverse it!'
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const response = await api.post(`/v1/reverse-purchase-invoice`, withCompanyId({
        invoice_id: item.id,
        invoice_number: item.invoice_number || item.document_number
      }));

      if (response.status === 200 || response.status === 201) {
        // Remove the item from the table
        setInvoices(invoices.filter(invoice => invoice.id !== item.id));
        Swal.fire({
          title: 'Success!',
          text: 'Purchase invoice reversed successfully.',
          icon: 'success',
          confirmButtonColor: '#3085d6'
        });
      }
    } catch (error) {
      console.error("Failed to reverse invoice:", error);
      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message?.invoice_number?.[0] || 'Error reversing purchase invoice. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3085d6'
      });
    }
  };




  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Purchase Invoice</h2>
          <h1 className={classes.Titles}>
            Manage your purchase transactions, supplier invoices, and payments.
          </h1>
        </header>

        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Purchase</p>
                <p className={classes.kdptg1}>{selectMetrics?.total_purchase?.toLocaleString() ?? '0'}</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This month</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Outstanding</p>
                <p className={classes.kdptg2}>{selectMetrics?.outstanding?.toLocaleString() ?? '0'}</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Pending payments</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>This month</p>
                <p className={classes.kdptg4}>{selectMetrics?.total_invoices?.toLocaleString() ?? '0'}</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total invoices</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search sales" />
            </div>
            <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>

            <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div>
          </div>
          <button className={classes.btnss} onClick={() => navigate("/transactions/purchase-invoice/purchase/new-item")}> + New purchases</button>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th>S/N</th>
                  <th>Invoice Number</th>
                  {/* <th>Description</th> */}
                  <th>Supplier Name</th>
                  <th>Transaction Date</th>
                  <th>Delivery Status</th>
                  <th>Payment Status</th>
                  <th>Amount</th>
                  <th>Post Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {loading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(10)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : invoices.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center" }}>
                        No purchase invoices found.
                      </td>
                    </tr>
                  ) : (
                    invoices.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.invoice_number || item.document_number || item.uuid}</td>
                        {/* <td>{item.description}</td> */}
                        <td>{item.supplier?.name || ""}</td>
                        <td>{item.transaction_date}</td>
                        <td className={getDeliveryStatus(item).class}>{getDeliveryStatus(item).text}</td>
                        <td className={statusClass(Number(item.balance) === 0 ? "Success" : Number(item.paid) > 0 ? "Pending" : "Pending")}>
                          {Number(item.balance) === 0 ? "Paid" : Number(item.paid) > 0 ? "Partially Paid" : "Pending"}
                        </td>
                        <td style={{ textAlign: 'right' }}>{Number(item.amount).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                        <td>{item.created_at ? item.created_at.split("T")[0] : ""}</td>
                        <td className={classes.actions}>
                          <Pen
                            size={16}
                            className={classes.editIcon}
                            role="button"
                            tabIndex={0}
                            aria-label={`Edit purchase invoice ${item.invoice_number || item.document_number || ""}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setEditingInvoice(item)}
                            onKeyDown={(event) => {
                              if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                setEditingInvoice(item);
                              }
                            }}
                          />
                          <Trash2 
                            size={16} 
                            className={classes.deleteIcon}
                            onClick={() => handleReversePurchaseInvoice(item)}
                            style={{ cursor: "pointer" }}
                          />
                          <Printer
                            size={16}
                            className={classes.printIcon}
                            role="button"
                            tabIndex={0}
                            aria-label={`Preview purchase invoice ${item.invoice_number || item.document_number || ""}`}
                            onClick={() => setPreviewInvoice(item)}
                            onKeyDown={(event) => {
                              if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                setPreviewInvoice(item);
                              }
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        </td>
                      </tr>
                    ))
                  )}
              </tbody>
            </table>


          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - 41 of 41</span>
            </div>
          </div>


        </div>
      </div>
      <Footer />
      {editingInvoice && (
        <div
          className={classes.editModalOverlay}
          role="presentation"
          onKeyDown={(event) => {
            if (event.key === "Escape") setEditingInvoice(null);
          }}
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setEditingInvoice(null);
          }}
        >
          <section
            className={classes.editModal}
            role="dialog"
            aria-modal="true"
            aria-labelledby="purchase-invoice-edit-title"
          >
            <header className={classes.editModalHeader}>
              <h2 id="purchase-invoice-edit-title">Edit Purchase Invoice</h2>
              <button
                type="button"
                className={classes.printPreviewClose}
                onClick={() => setEditingInvoice(null)}
                aria-label="Close edit form"
              >
                ×
              </button>
            </header>
            <div className={classes.editModalBody}>
              <NewItem
                invoice={editingInvoice}
                embedded
                onClose={() => setEditingInvoice(null)}
              />
            </div>
          </section>
        </div>
      )}
      {previewInvoice && (
        <div
          className={classes.printPreviewOverlay}
          role="presentation"
          onKeyDown={(event) => {
            if (event.key === "Escape") setPreviewInvoice(null);
          }}
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setPreviewInvoice(null);
          }}
        >
          <section
            className={classes.printPreviewModal}
            role="dialog"
            aria-modal="true"
            aria-labelledby="purchase-invoice-preview-title"
          >
            <header className={classes.printPreviewHeader}>
              <h2 id="purchase-invoice-preview-title">Purchase Invoice Preview</h2>
              <button
                type="button"
                className={classes.printPreviewClose}
                onClick={() => setPreviewInvoice(null)}
                aria-label="Close preview"
              >
                ×
              </button>
            </header>
            <div className={classes.printPreviewBody}>
              <article id="purchase-invoice-modal-print" className={invoicePreviewClasses["invoice-box"]} ref={printRef}>
                <div className={invoicePreviewClasses.watermark}>UNPAID</div>
                <div className={invoicePreviewClasses.header}>
                  <div className={invoicePreviewClasses.company}>
                    <img
                      src={companyLogo}
                      alt="Company Logo"
                      className={invoicePreviewClasses.companyLogo}
                    />
                    <div>
                      <h2>Promix Accounting Ltd</h2>
                      <small>
                        123 Business District Victoria Island, Lagos
                        <br />
                        +234 801 234 5678 | info@promix.com
                      </small>
                    </div>
                  </div>
                  <div className={invoicePreviewClasses["invoice-title"]}>
                    <h1>Purchase Invoice</h1>
                    <p>
                      Invoice No: {previewInvoice.invoice_number || previewInvoice.document_number || previewInvoice.uuid || "—"}
                      <br />
                      Date: {previewInvoice.transaction_date || previewInvoice.invoice_date || "—"}
                      <br />
                      Due Date: {previewInvoice.due_date || "—"}
                    </p>
                  </div>
                </div>
                <table className={invoicePreviewClasses.info}>
                  <tbody>
                    <tr>
                      <td>
                        <strong>BILL TO</strong>
                        <br />
                        {previewInvoice.supplier?.name || previewInvoice.supplier_name || "—"}
                        <br />
                        {previewInvoice.supplier?.address || "123 Business District Victoria Island, Lagos"}
                        <br />
                        {previewInvoice.supplier?.phone_number || "+234 801 234 5678"}
                      </td>
                      <td>
                        <strong>Payment Terms</strong>
                        <br />
                        {previewInvoice.payment_terms || "Due on receipt"}
                      </td>
                      <td className={classes.invoiceQrCell}>
                        <div className={classes.invoiceQrCode}>
                          <QRCodeSVG value={qrCodeValue} size={96} level="M" includeMargin />
                          <span>Invoice details</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className={invoicePreviewClasses.items}>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Description</th>
                      <th>Qty</th>
                      <th>Unit Price (₦)</th>
                      <th>Amount (₦)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {previewItems.length > 0 ? previewItems.map((item, index) => {
                      const quantity = Number(item.quantity ?? item.qty ?? 1);
                      const lineAmount = Number(item.item_amount ?? item.line_total ?? item.total ?? item.amount ?? 0);
                      const unitPrice = Number(item.unit_price ?? item.price ?? item.rate ?? (quantity ? lineAmount / quantity : lineAmount));
                      const title = item.item?.name || item.product?.name || item.name || item.reference || item.description || "—";
                      return (
                        <tr key={item.id ?? index}>
                          <td>{index + 1}</td>
                          <td>{title}</td>
                          <td>{quantity}</td>
                          <td>{formatInvoiceAmount(unitPrice)}</td>
                          <td>{formatInvoiceAmount(lineAmount)}</td>
                        </tr>
                      );
                    }) : (
                      <tr>
                        <td>1</td>
                        <td>{previewInvoice.description || "Purchase invoice"}</td>
                        <td>1</td>
                        <td>{formatInvoiceAmount(previewTotal)}</td>
                        <td>{formatInvoiceAmount(previewTotal)}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={invoicePreviewClasses.totals}>
                  <table>
                    <tbody>
                      <tr>
                        <td>Subtotal</td>
                        <td style={{ textAlign: "right" }}>{formatInvoiceAmount(previewSubtotal)}</td>
                      </tr>
                      {previewVat !== 0 && (
                        <tr>
                          <td>VAT (7.5%)</td>
                          <td style={{ textAlign: "right" }}>{formatInvoiceAmount(previewVat)}</td>
                        </tr>
                      )}
                      {previewDiscount !== 0 && (
                        <tr>
                          <td>Discount</td>
                          <td style={{ textAlign: "right" }}>- {formatInvoiceAmount(previewDiscount)}</td>
                        </tr>
                      )}
                      <tr>
                        <td>Total</td>
                        <td style={{ textAlign: "right" }}>{formatInvoiceAmount(previewTotal)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className={invoicePreviewClasses.clear} />
                <div className={invoicePreviewClasses.section}>
                  <strong>Payment Details</strong>
                  <br />
                  {companyBankName}
                  <br />
                  {companyAccountName}
                  <br />
                  {companyAccountNumber}
                </div>
                <div className={invoicePreviewClasses.section}>
                  <strong>Notes</strong>
                  <br />
                  Please make payment on or before the due date.
                  <br />
                  Thank you for your business.
                </div>
                <div className={invoicePreviewClasses.signature}>
                  ___________________________
                  <br />
                  Authorized Signature
                </div>
                <div className={invoicePreviewClasses.printFooter}>
                  Created by
                  <br />
                  <a
                    href="https://promixaccounting.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://promixaccounting.com
                  </a>
                </div>
              </article>
            </div>
            <footer className={classes.printPreviewActions}>
              <button type="button" className={classes.printPreviewSecondary} onClick={() => setPreviewInvoice(null)}>
                Close
              </button>
              <button type="button" className={classes.printPreviewSecondary} onClick={printPreview}>
                Print
              </button>
              <button type="button" className={classes.printPreviewPrimary} onClick={handleOpenFullPreview}>
                Open full preview
              </button>
            </footer>
          </section>
        </div>
      )}
    </div>
  );
};

export default Purchase;
